/* eslint-disable */ 
import Vue from 'vue'
import {mapActions} from 'vuex'

const ErrorHandlingService = {
  ...mapActions('snackbar', [
    'showSnackbar'
  ]),

  init(store) {
    // noinspection JSUnusedGlobalSymbols
    this.$store = store

    Vue.config.errorHandler = (err, vm, info) => {
      if(err.name !== 'FhNetworkError' && err.name !== 'FhTemporaryError' && err.name !== 'FhBackendError') {
        this.showSnackbar(['Error inesperado. Favor intente más tarde.'])
        console.log('Error desconocido: ', err, vm, info)
      }
    }
  },
}

export default ErrorHandlingService
